module.exports = __webpack_public_path__ + "static/add-site.7270b324.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ThePlatform/add-site.png
// module id = 456
// module chunks = 145206920446059